var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('client-header',{attrs:{"image":_vm.tracking}}),_vm._v(" "),_c('div',{staticClass:"position-lg-absolute w-100",staticStyle:{"bottom":"-15%"}},[_c('client-search',{attrs:{"class-body":"rounded shadow bg-white","to":"ClientLocator","width":"87%"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd5a77a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clients/Client.vue
// module id = null
// module chunks = 